(() => {
  function initialize() {
    document.querySelectorAll('.sg-page').forEach(page => {
      if (page.dataset.ready) return;
      page.dataset.ready = 'true';
      const toggle = page.querySelector('.sg-menu-toggle');
      const menu = page.querySelector('.sg-mobile-nav');
      toggle?.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        menu.hidden = !open;
      });
      menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      }));
      page.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !menu.hidden) {
          toggle.setAttribute('aria-expanded', 'false');
          menu.hidden = true;
          toggle.focus();
        }
      });
      if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        page.classList.add('sg-motion');
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('sg-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.08 });
        page.querySelectorAll('.sg-reveal').forEach(element => observer.observe(element));
      }
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
